import React from "react";
import ListTemplate from "components/ListTemplate";
import Filters from "./Filters";
import SmallDetails from "components/SmallDetails/SmallDetails";
import moment from "moment";
import { formatShortDate } from "utilities/momentutils";
import { routes } from "utilities/routing/generatedRoutes";
import { CompanySmallDetails, InvoiceSmallDetails } from "components/SmallDetails";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";

const ReceivedOn = ({ payment }: { payment: server.dto.PaymentForList }) => {
  return <SmallDetails
    label={formatShortDate(moment.utc(payment.receivedOn))}
    subLabel={payment.method.text}
    link={routes.payment_Detail(payment.paymentId).absolute}
  />;
};

const Amount = ({ payment }: { payment: server.dto.PaymentForList }) => {
  return <span className={payment.amount.amount < 0 ? "blue" : ""}>
    {payment.amount.formatted}
  </span>;
};

const PaymentListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.PaymentListFrontModel>();

  return <ListTemplate
    title={RESX.Payment.Payments}
    filterSet="payment_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Payment.Paginated}
    getId={item => item.paymentId}
    layout={{
      type: "table",
      columns: [{
        key: "receivedOn",
        header: RESX.Payment.ReceivedOn,
        render: item => <ReceivedOn payment={item} />,
        size: "1fr"
      }, {
        key: "amount",
        header: RESX.Payment.Amount,
        render: item => <Amount payment={item} />,
        className: "s1_cell_financialamount",
        size: "auto"
      }, {
        key: "receivedFrom",
        header: RESX.Payment.ReceivedFrom,
        render: item => <CompanySmallDetails company={item.receivedFrom} layout="singleLine" />,
        size: "2fr"
      }, {
        key: "assignedToInvoice",
        header: RESX.Payment.AssignedToInvoice,
        render: item => <InvoiceSmallDetails invoice={item.assignedToInvoice} />,
        size: "140px"
      }, {
        key: "description",
        header: RESX.GeneralLabels.Description,
        render: item => item.description,
        size: "2fr"
      }]
    }}
    filters={<Filters initialBookkeepings={viewModel.bookkeepings} />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
    options={{
      exportOptions: {
        canExportList: site.permissions.invoice.canExportList,
        exportOptionsApi: window.CoreApi.Payment.ExportOptionsForList
      }
    }}
  />;
};

export default PaymentListApp;